module.exports = __webpack_public_path__ + "static/media/john-matais.34e3531d.png";